/* Library */
import React, { Component } from 'react';
import InputButton from '../../../../../components/ZUILib/InputButton';
import commonUtil from '../../../../../utils/commonUtil';

export default class ValeSystemModal extends Component {
  render() {
    const Aceptar = {
      id: 'closeModal',
      type: 'button',
      value: 'Aceptar',
      autoFocus: false,
      style: 'btnPrimaryAction size-Full',
    };
    return (
      <div className="row">
        <div className="col-md-12">
          <p>{commonUtil.getLabel(this.props.lables['Event Account Landing page – Vales system down'], 'accountStatement.valesystemdown.message2')} {this.props.startTime} a {this.props.endTime} {commonUtil.getLabel(this.props.lables['Event Account Landing page – Vales system down'], 'accountStatement.valesystemdown.message3')}.</p>
          <div className="row">
            <div className="col-md-8 col-sm-8 col-md-offset-2 text-center">
              <InputButton buttonAttr={Aceptar}><i className="icon-flecha_gruesa_abajo" /></InputButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
